<template>
<div class="row wrapper page-row-wrapper">
  <slot></slot>
</div>
</template>

<script>
export default {
  name: 'PageRowWrapper'
}
</script>

<style scoped>
.page-row-wrapper {
  margin-top: 40px;
}
</style>
